import script from "./Options.vue?vue&type=script&setup=true&lang=tsx"
export * from "./Options.vue?vue&type=script&setup=true&lang=tsx"

import "./Options.vue?vue&type=style&index=0&id=85d7ae40&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85d7ae40"]])

export default __exports__